import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '@redux/store';
import WishListCard from '../molecules/WishListCard'

export interface WishListProps {
  header?: string
}

const Wishlist: React.FC<WishListProps> = ({ header = 'Wishlist'}) => {
  const wishlistItems = useSelector((state: RootState) => state.wishlist.items);

  return (
    <>
      {wishlistItems.length === 0 ? (
        <></>
      ) : (
        <div className="pt-8 pb-10 px-5 lg:px-16">
          <h2 className="text-black h1 font-appleGaramond font-light pb-5 lg:pb-6">{header}</h2>
          <div className="grid grid-cols-2 gap-2 lg:grid-cols-6 lg:gap-x-2 lg:gap-y-6">
            {wishlistItems.map((item) => (
              <WishListCard
                key={item.product.id}
                product={item.product}
                selectedVariant={item.selectedVariant}
              />
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default Wishlist;
